import {
    RefundPolicyCode,
    RefundPolicyCodeWithoutValidityDays,
} from '../api/models/refundPolicy';

export const fallbackRefundPolicyValidityDaysByRefundPolicyCode: Record<
    Exclude<RefundPolicyCode, RefundPolicyCodeWithoutValidityDays>,
    number
> &
    Record<RefundPolicyCodeWithoutValidityDays, null> = {
    [RefundPolicyCode.flexible]: 1,
    [RefundPolicyCode.moderate]: 7,
    [RefundPolicyCode.strict]: 30,
    [RefundPolicyCode.noRefunds]: null,
    [RefundPolicyCode.notDefined]: null,
    [RefundPolicyCode.custom]: null,
};

export const isRefundPolicyCodeWithValidityDays = (
    refundPolicyCode: RefundPolicyCode,
): refundPolicyCode is Exclude<
    RefundPolicyCode,
    RefundPolicyCodeWithoutValidityDays
> =>
    fallbackRefundPolicyValidityDaysByRefundPolicyCode[refundPolicyCode] !==
    null;
